import { defaultTheme } from './default';

export const altTheme = {
  ...defaultTheme,
};
